var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"rule",attrs:{"title":_vm.help}},[_vm._v("Set "+_vm._s(_vm.columnsLabel)+" as "+_vm._s(_vm.typeDisplay))])
}
var staticRenderFns = []

export { render, staticRenderFns }